<template>
    <div>
        <div class="content-header">
            <el-form :inline="true" class="demo-form-inline select-wrap">
                <el-form-item>
                    <el-select v-model="formInline.bindCode" clearable placeholder="请选择活动">
                        <el-option
                            v-for="item in actives"
                            :key="item.bindCode"
                            :label="item.activeName"
                            :value="item.bindCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchPrducts" :loading="searchLoading">查询</el-button>
                    <el-button type="primary" plain @click="addProductLine">新增</el-button>
                    <el-button type="warning" @click="copyWindow">从另一个活动复制</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="productList" center v-loading="loading">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column label="商品图片">
                    <template slot-scope="scope">
                        <img :src="scope.row.productPic" width="25" height="25" class="head_pic"/>
                    </template>
                </el-table-column>
                <el-table-column prop="barcode" label="69码"></el-table-column>
                <el-table-column prop="productName" label="名称"></el-table-column>
                <el-table-column label="类型">
                    <template  slot-scope="scope">
                        <el-tag v-if="scope.row.productType==1">回收品</el-tag>
                        <el-tag v-if="scope.row.productType==2" type="danger">兑换品</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="兑换品类型">
                    <template  slot-scope="scope">
                        <el-tag v-if="scope.row.productType==1">-</el-tag>
                        <el-tag v-if="scope.row.productType==2&&scope.row.swapProductType==1">小岛特产</el-tag>
                        <el-tag v-if="scope.row.productType==2&&scope.row.swapProductType==2">锦鲤特产</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="lovePrice" label="爱心值"></el-table-column>
                <el-table-column prop="minLimit" label="最小数量"></el-table-column>
                <el-table-column prop="maxLimit" label="最大数量"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)"></el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)"></el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalRecord">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="复制活动商品" :visible.sync="showDialog" width="30%" center class="main-title">
            <el-form>
                <el-form-item label="要复制的活动">
                    <el-select v-model="copyBindCode" clearable placeholder="请选择活动">
                        <el-option
                            v-for="item in actives"
                            :key="item.bindCode"
                            :label="item.activeName"
                            :value="item.bindCode">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveCopy" class="header-btn">保 存</el-button>
            </div>
        </el-dialog>
        <!-- 新增编辑window -->
        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible"center top="5vh">
            <el-form :model="reunionProductForm" label-width="120px" size="small ">
                <el-form-item label="选择商品" :required="true">
                    <el-select v-model="reunionProductForm.productId" :disabled="disableFlag" placeholder="请选择商品" @change="changeProduct(proId)">
                        <el-option
                            v-for="item in products"
                            :key="item.proId"
                            :label="item.proName"
                            :value="item.proId">
                            <span style="float: left">{{ item.proName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.barcode }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型" :required="true">
                    <el-select v-model="reunionProductForm.productType" :disabled="disableFlag" size="mini">
                        <el-option label="回收品" :value="1"></el-option>
                        <el-option label="兑换品" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="兑换商品类型" :required="true" v-show="reunionProductForm.productType==2">
                    <el-select v-model="reunionProductForm.swapProductType" size="mini">
                        <el-option
                                v-for="item in swapProductTypeList"
                                :key="parseInt(item.id)"
                                :label="item.name"
                                :value="parseInt(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="爱心值">
                    <el-input-number v-model="reunionProductForm.lovePrice" :disabled="disableFlag" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="最小数量">
                    <el-input-number v-model="reunionProductForm.minLimit"></el-input-number>
                </el-form-item>
                <el-form-item label="最大数量" >
                    <el-input-number v-model="reunionProductForm.maxLimit"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveOrUpdateReunionProduct()" :loading="saveLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {getActiveForOptionListByType,getProductByProType,productList,saveProdcts,deleteProduct,copyProdcts,getDictionary} from '../../api/api'
export default {
    data(){
        return{
            loading : false,
            saveLoading : false,
            searchLoading : false,
            showDialog : false,
            dialogFormVisible : false,
            actives : [],
            products : [],
            swapProductTypeList:[],
            formInline : {
                bindCode : '',
                currentPage:1,
                recordsTotal:0,
                pageSize:50,
            },
            productList : [],
            copyBindCode : '',
            disableFlag:true,
            reunionProductForm : {
                id : 0,
                bindCode : "",
                productId : "",
                productType : "",
                lovePrice : 0,
                maxLimit : 0,
                swapProductType:0,
                minLimit : 0
            }
        }
    },
    mounted(){
        this.getActives();
        this.getProducts();
        this.getSwapProductTypeList();
    },
    methods:{
        getActives(){
            getActiveForOptionListByType({activeType : 30}).then((res) => {
                if(res.data.status==200){
                    this.actives = res.data.value;
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        getProducts(){
            getProductByProType({proType : '11'}).then((res) => {
                if(res.data.status==200){
                    this.products = res.data.value;
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        searchPrducts(){
            if(this.formInline.bindCode == null || this.formInline.bindCode == ''){
                this.$message.error('请选择活动');
                return;
            }
            this.loading = true;
            this.searchLoading = true;
            productList(this.formInline).then((res) => {
                this.productList = res.data.list;
                this.formInline.recordsTotal = res.data.total;
                this.loading = false;
                this.searchLoading = false;
            })
        },
        addProductLine(){
            if(this.formInline.bindCode == null || this.formInline.bindCode == ''){
                this.$message.error('请选择活动');
                return;
            };
            this.disableFlag=false;
            this.reunionProductForm = {
                id : 0,
                bindCode : this.formInline.bindCode,
                productId : "",
                productType : "",
                lovePrice : 0,
                maxLimit : 0,
                swapProductType:0,
                minLimit : 0
            };
            this.dialogFormVisible = true;
        },
        getSwapProductTypeList(){
            getDictionary({dictionaryTypeId:60,dictionaryKey:'3'}).then((res) => {
                if(res.data.status==200){
                    this.swapProductTypeList=JSON.parse(res.data.value.dictionaryName);
//                    let arr =  JSON.parse(res.data.value.dictionaryName);
//                    console.log(arr)
//                    for (const elem of arr) {
//                        let temp={id:parseInt(elem.id),name:elem.name};
//                        this.swapProductTypeList.push(temp);
//                    }
                    console.log(this.swapProductTypeList)
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        handleEdit(row){
            this.disableFlag=true;
            this.reunionProductForm.id = row.id;
            this.reunionProductForm.bindCode = row.bindCode;
            this.reunionProductForm.productId = row.productId;
            this.reunionProductForm.productType = row.productType;
            this.reunionProductForm.lovePrice = row.lovePrice;
            this.reunionProductForm.maxLimit = row.maxLimit;
            this.reunionProductForm.minLimit = row.minLimit;
            this.reunionProductForm.swapProductType=row.reunionProductForm;
            this.dialogFormVisible = true;
        },
        getDisableStatus(){
            return this.reunionProductForm.id>=0;
        },
        handleDelete(id){
            this.$confirm('删除该商品?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteProduct({'id':id}).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                }).catch(() => {

                });
                this.searchPrducts();
            });
        },
        changeProduct(pro){
            // row.listTemplateFile = '';
            // row.barcode = '69000000';
            console.log('chosen-pro',pro)
        },
        saveOrUpdateReunionProduct(){
            this.saveLoading = true;
            saveProdcts(this.reunionProductForm).then((res) => {
                if(res.data.status==200){
                    this.$message({
                        showClose: true,
                        message: '成功',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
                this.searchPrducts();
                this.saveLoading = false;
            })
        },
        copyWindow(){
            if(this.formInline.bindCode == null || this.formInline.bindCode == ''){
                this.$message.error('请选择活动');
                return;
            }
            this.showDialog = true;
        },
        saveCopy(){
            if(this.formInline.bindCode == null || this.formInline.bindCode == ''){
                this.$message.error('请先在页面上选择要创建商品的活动');
                return;
            }
            if(this.copyBindCode == null || this.copyBindCode == ''){
                this.$message.error('请选择要复制的活动');
                return;
            }
            copyProdcts({bindCode : this.formInline.bindCode,copyFromBindCode:this.copyBindCode}).then((res) => {
                if(res.data.status==200){
                    this.$message({
                        showClose: true,
                        message: '成功',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
                this.searchPrducts();
                this.showDialog = false;
            })
        },
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.searchPrducts();
        },
        handleCurrentChange(val) {
            this.formInline.currentPage = val;
            this.searchPrducts();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/reunion/ReunionProduct.vue